<div class="section section-padding pb-0">
    <div class="row">
        <!-- Data -->
        <div class="col-md-3" *ngFor="let item of counter">
            <div class="sigma_counter">
                <i [class]="item.icon"></i>
                <span> <b class="text-white counter" [countUp]="item.value">0</b> <span class="custom-primary">+</span>
                </span>
                <p class="custom-dark">{{item.title}}</p>
            </div>
        </div>
        <!-- Data -->
    </div>
</div>